<ng-container *ngIf="!isLoading; else loadingAnimation">
    <form [formGroup]="form">
        <div class="pcbs"
             formArrayName="requiredSampleBoards"
             *ngFor="let item of arrayControl.controls; let i = index;">
            <div class="pcb-row"
                 [class.pcb-row-with-remove]="canDeleteItems"
                 [class.pcb-row-no-remove]="!canDeleteItems"
                 [formGroupName]="i">
                <app-dropdown-autocomplete
                    class="sample-board"
                    [label]="'admin.strain.registry.create.step4.sampleBoard' | translate"
                    [items]="sampleBoards"
                    displayField="name"
                    valueField="id"
                    appendTo="body"
                    [formControl]="sampleBoardControl(i)"
                    [disabled]="!canAddItems"
                    [showErrors]="(showValidations || sampleBoardControl(i).touched) && sampleBoardControl(i).invalid"
                    [canAddOther]="false">
                </app-dropdown-autocomplete>

                <app-input class="required"
                           type="number"
                           [label]="'admin.strain.registry.create.step4.requiredQuantity' | translate"
                           [formControl]="requiredQuantityControl(i)"
                           [showErrors]="(showValidations || requiredQuantityControl(i).touched) && requiredQuantityControl(i).invalid">
                </app-input>

                <app-input class="spare"
                           type="number"
                           [label]="'admin.strain.registry.create.step4.spareQuantity' | translate"
                           [formControl]="spareQuantityControl(i)"
                           [showErrors]="(showValidations || spareQuantityControl(i).touched) && spareQuantityControl(i).invalid">
                </app-input>
                <app-icon class="delete" library="fontawesome" variant="fa-minus" type="danger" (click)="removeItem(i)"></app-icon>
            </div>
        </div>
        <ng-container *ngIf="arrayControl.controls.length === 0 then noItems"></ng-container>
        <app-button *ngIf="canAddItems"
                    type="primary"
                    class="pcb_add"
                    (click)="addItem()">
            <i class="material-icons add">add</i>
        </app-button>
    </form>
</ng-container>

<ng-template #noItems let-index='index'>
    <app-alert [responsive]="true"
               type="info"
               message="{{'admin.strain.registry.create.step4.info'| translate}}">
    </app-alert>
</ng-template>

<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
